import { render, staticRenderFns } from "./batchConfirmDialog.vue?vue&type=template&id=55fbd828"
import script from "./batchConfirmDialog.vue?vue&type=script&lang=js"
export * from "./batchConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports